'use strict'

/**
 * Demo/test-only serial fabricator for upstream fixtures.
 * Production identity trusts the database serial — see sourceUnitIdentity.js.
 */

import {UNIT_KINDS} from '../constants'

const SOURCE_KIND_SUFFIX = Object.freeze({
  [UNIT_KINDS.BAR]: '',
  [UNIT_KINDS.HOUSE_PIN]: '-HP',
  [UNIT_KINDS.CUSTOMER_PIN]: '-CP',
})

/**
 * @param {{sourceLotCode: string, barNumber: number|string, kind: string}} args
 * @returns {string}
 */
export const fixtureSourceUnitSerial = ({sourceLotCode, barNumber, kind}) => {
  const suffix = SOURCE_KIND_SUFFIX[kind]
  if (suffix === undefined) {
    throw new Error(`unsupported fixture source kind: ${kind}`)
  }
  return `${sourceLotCode}-${barNumber}${suffix}`
}
